<template>
  <input-widget :model="model" :attribute="attribute" :items="items" type="select2"
                value-field="key" :label="label" :options="computedOptions" :multiple="multiple"
                display-field="${item.text}"/>
</template>

<script>
  import InputWidget from "@/core/components/input-widget/InputWidget";
  import i18n from "@/shared/i18n";

  export default {
    name: "TemporaryItemProgressSelectInputWidget",
    components: {InputWidget},
    props: {
      model: {
        type: Object,
        required: true,
      },
      attribute: {
        type: String,
        required: true,
      },
      options: {
        type: Object,
        required: false,
        default: () => {
          return {placeholder: i18n.t('Progress')}
        }
      },
      multiple: {
        type: Boolean,
        default: false
      },
      label: {
        type: [String, Boolean],
        default: null
      },
    },
    computed: {
      items() {
        return [
          {key: 'pending', text: i18n.t('Pending')},
          {key: 'processing', text: i18n.t('Processing')},
          {key: 'completed', text: i18n.t('Completed')},
        ]
      },
      computedOptions() {
        return {...this.options, multiple: this.multiple}
      }
    }
  }
</script>

<style scoped>

</style>
